import React from 'react';
import { MessageCircle, Phone, Calendar } from 'lucide-react';
import { useProperties } from '../context/PropertyContext';

export const MobileStickyBar = ({ currentProperty = null }) => {
  const { getWhatsAppLink, recordWhatsAppClick } = useProperties();

  const handleScrollToSchedule = (e) => {
    e.preventDefault();
    const el = document.getElementById('agendar-visita');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      // Add a subtle highlight pulse to the form
      el.style.transition = 'box-shadow 0.4s ease, border-color 0.4s ease';
      el.style.boxShadow = '0 0 0 3px rgba(243, 207, 104, 0.6)';
      setTimeout(() => {
        el.style.boxShadow = 'none';
      }, 2000);
    }
  };

  if (currentProperty) {
    const isRent = (currentProperty.operationType || currentProperty.operation) === 'Renta' || (currentProperty.operationType || currentProperty.operation) === 'renta';
    const effectivePrice = Number(currentProperty.priceMXN || currentProperty.price || 0);
    const originalPrice = Number(currentProperty.originalPriceMXN || currentProperty.originalPrice || 0);
    const hasDiscount = Boolean(currentProperty.hasDiscount || (originalPrice > 0 && originalPrice > effectivePrice));
    const discountPct = hasDiscount && originalPrice > 0
      ? Math.round(((originalPrice - effectivePrice) / originalPrice) * 100)
      : 0;

    const formattedPrice = new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: currentProperty.currency || 'MXN',
      maximumFractionDigits: 0
    }).format(effectivePrice);

    const waMessage = `Hola Lic. Edgar Molina, deseo información y agendar visita para la propiedad: ${currentProperty.title || 'Inmueble'} (${currentProperty.location?.neighborhood ? 'Col. ' + currentProperty.location.neighborhood + ', ' : ''}${currentProperty.location?.city || 'Parral'}).`;

    return (
      <aside className="mobile-sticky-bar" aria-label="Botonera flotante de contacto">
        <div className="mobile-sticky-detail-flex">
          {/* Price & Discount */}
          <div className="mobile-sticky-price-block">
            <div className="mobile-sticky-price-val">
              {formattedPrice}
              {isRent && <span style={{ fontSize: '0.75rem', fontWeight: 400, color: 'rgba(255,255,255,0.7)' }}>/mes</span>}
            </div>
            <div className="mobile-sticky-price-sub">
              {hasDiscount && discountPct > 0 ? (
                <span style={{ backgroundColor: '#ef4444', color: '#ffffff', padding: '1px 5px', borderRadius: '4px', fontWeight: 800 }}>
                  -{discountPct}%
                </span>
              ) : (
                <span>Precio de {isRent ? 'Renta' : 'Venta'}</span>
              )}
            </div>
          </div>

          {/* Action Buttons: Agendar + WhatsApp */}
          <div className="mobile-sticky-btn-group">
            <button
              type="button"
              className="btn-mobile-schedule"
              onClick={handleScrollToSchedule}
              aria-label="Agendar recorrido de visita"
            >
              <Calendar size={15} color="var(--color-accent)" />
              <span>Agendar</span>
            </button>

            <a
              href={getWhatsAppLink(waMessage)}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-mobile-wa"
              onClick={() => currentProperty.id && recordWhatsAppClick(currentProperty.id)}
              aria-label="Contactar directamente por WhatsApp"
            >
              <MessageCircle size={16} />
              <span>WhatsApp</span>
            </a>
          </div>
        </div>
      </aside>
    );
  }

  // Fallback for General Site Pages
  const generalWaMessage = 'Hola Lic. Edgar Molina, quiero solicitar asesoría inmobiliaria y jurídica en Parral.';

  return (
    <aside className="mobile-sticky-bar" aria-label="Botonera flotante de contacto rápido">
      <div className="mobile-sticky-actions">
        <a
          href="tel:6272792964"
          className="btn-mobile-call"
          aria-label="Llamar directamente al 6272792964"
        >
          <Phone size={16} />
          <span>Llamar</span>
        </a>

        <a
          href={getWhatsAppLink(generalWaMessage)}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-mobile-wa"
          aria-label="Enviar mensaje de WhatsApp al 6272792964"
        >
          <MessageCircle size={16} />
          <span>WhatsApp</span>
        </a>
      </div>
    </aside>
  );
};
